import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/dashboard" },
  {
    path: "/home",
    redirect: "/dashboard",
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/pages/AboutView.vue"),
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: () => import("@/views/pages/ContactView.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: { layout: "blank" },
    component: () => import("@/views/LoginPage.vue"),
  },
  {
    path: "/mobile-login",
    name: "mobile-login",
    meta: { layout: "blank" },
    component: () => import("@/views/MobileLogin.vue"),
  },
  {
    path: "/event/booking",
    name: "Event Booking",
    component: () => import("@/views/event/EventBooking.vue"),
  },
  {
    path: "/order/success",
    name: "Order Success",
    component: () => import("@/views/event/PaymentSuccess.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("@/views/DashboardPage.vue"),
  },
  {
    path: "/event-participant/list",
    name: "Event Participants",
    component: () =>
      import("@/views/event_participant/EventParticipantsList.vue"),
  },
  {
    path: "/event-participant/upload",
    name: "Upload Event Participants",
    component: () =>
      import("@/views/event_participant/EventParticipantsUpload.vue"),
  },
  {
    path: "/event-participant/accommodation-update",
    name: "Event Participants Accommodation Update",
    component: () =>
      import(
        "@/views/event_participant/EventParticipantsAccommodationUpdate.vue"
      ),
  },
  {
    path: "/event-participant/create",
    name: "Add New Event Participant",
    component: () =>
      import("@/views/event_participant/AddEventParticipant.vue"),
  },
  {
    path: "/amenity/list",
    name: "Amenity List",
    component: () => import("@/views/amenity/AmenityList.vue"),
  },
  {
    path: "/plan-amenity/list",
    name: "Event Plan Amenities",
    component: () => import("@/views/amenity_plan/AmenityPlanList.vue"),
  },
  {
    path: "/report/amenity-given",
    name: "Amenity Participant Report",
    component: () => import("@/views/report/AmenityParticipantReport.vue"),
  },
  {
    path: "/user/list",
    name: "Users List",
    component: () => import("@/views/user/UserList.vue"),
  },
  {
    path: "/report/participant-report",
    name: "Participant Report",
    component: () => import("@/views/report/ParticipantReport.vue"),
  },
  {
    path: "/idcard/idcard-print-list",
    name: "Idcard Print List",
    component: () => import("@/views/idcard/IdCardPrintList.vue"),
  },
  {
    path: "/idcard/update-idcard-upload",
    name: "Update ID Card Upload",
    component: () => import("@/views/idcard/UpdateIdCardUpload.vue"),
  },
  {
    path: "/add-event-participant/create",
    name: "New Event Participant",
    component: () =>
      import("@/views/event_participant/AddEventParticipantCreate.vue"),
  },
  {
    path: "/plan-create",
    name: "Plan Create",
    component: () => import("@/views/amenity_plan/PlanCreate.vue"),
  },
  {
    path: "/add-event-participant/edit",
    name: "Event Participant Edit",
    component: () =>
      import("@/views/event_participant/EventParticipantsEdit.vue"),
  },
  {
    path: "/id-card-print/edit",
    name: "Id Card Print Edit",
    component: () => import("@/views/idcard/IdCardPrintEdit.vue"),
  },
  {
    path: "/conference-event/create",
    name: "Conference Event Create",
    component: () =>
      import("@/views/conference_event/ConferenceEventCreate.vue"),
  },
  {
    path: "/conference-event/list",
    name: "Conference Event List",
    component: () => import("@/views/conference_event/ConferenceEventList.vue"),
  },

  {
    path: "/conference-registration/list",
    name: "Conference Resgistration List",
    component: () =>
      import("@/views/conference_registration/ConferenceRegistrationList.vue"),
  },

  {
    path: "/conference-news/list",
    name: "Conference News List",
    component: () => import("@/views/conference_news/ConferenceNewsList.vue"),
  },

  {
    path: "/conference-sponsor/list",
    name: "Conference Sponsor List",
    component: () =>
      import("@/views/conference_sponsor/ConferenceSponsorList.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  var ToName = to.name;
  if (ToName) {
    // showLoader();
  }

  var fromPath = from.path;
  var toPath = to.path;
  console.log("navigation from=" + fromPath + ", to=" + toPath);
  // var server_url = companyConfig.apiURL;
  // console.log({ server_url });

  var token = localStorage.getItem("token");
  token = token == (null || undefined) ? "" : token;
  console.log({ token });

  if (
    to.path == "/" ||
    to.path == "/login" ||
    to.path == "/mobile-login" ||
    to.path == "/register" ||
    to.path == "/verify-otp" ||
    to.path == "/forgot-password" ||
    to.path == "/pages/error-404" ||
    to.path == "/pages/error-500" ||
    to.path == "/pages/register" ||
    to.path == "/callback" ||
    to.path == "/pages/not-authorized" ||
    to.path == "/pages/comingsoon"
  ) {
    console.log("navigation true");
    next();
  } else {
    console.log("navigation false");
    if (token != "") {
      console.log("token is valid");
      next();
    } else {
      console.log("session is expired");
      router.push("/login");
    }
  }
});

export default router;
